import "./styles/index.scss";
import { setCountryAndLanguage, translate } from "./translation";
import "./footer.ts";

import QRCode from "qrcode";

var canvas = document.getElementById("enable2faQrCode") as HTMLCanvasElement;
var url = canvas?.getAttribute("qr-code-url");

if (canvas != undefined && url != undefined) {
  QRCode.toCanvas(canvas, url, { scale: 1, width: 100, errorCorrectionLevel: "L"}, (error) => {
    if (error) {
      console.error(error);
    }
  });
}


Array.from(document.getElementsByClassName("copy-to-clipboard")).forEach((element, index, array) => {

  element.addEventListener("click", (e: Event) => {
    var codeElement = document.getElementsByClassName("recovery-codes")[0];

    if (!codeElement || !codeElement.childNodes)
      return;

    let codes: string[] = [];

    Array.from(codeElement.getElementsByTagName("div")).forEach((element, index, array) => {
      codes.push(element.innerText);
    });

    const selBox = document.createElement("textarea");
    selBox.style.opacity = "0";
    selBox.value = codes.join("\r\n");
    document.body.appendChild(selBox);
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  });
});


Array.from(document.getElementsByClassName("download-content")).forEach((element, index, array) => {

  element.addEventListener("click", (e: Event) => {
    var codeElement = document.getElementsByClassName("recovery-codes")[0];

    if (!codeElement || !codeElement.childNodes)
      return;

    let codes: string[] = [];

    Array.from(codeElement.getElementsByTagName("div")).forEach((element, index, array) => {
      codes.push(element.innerText);
    });

    const a = document.createElement("a");
    a.href = "data:text/plain;base64," + btoa(codes.join("\r\n"));
    a["download"] = "codes.txt";
    a.click();
  });
});


/*
const modal = document.querySelector("#lang-modal");
const btn = document.querySelector("#lang-modal .btn");
const btnLangSwitch = document.querySelector<HTMLDivElement>("#lang-switch");
const txtLang = btnLangSwitch!.querySelector(".text")!;
const btnCountrySwitch = document.querySelector<HTMLDivElement>("#country-switch");
const txtCountry = btnCountrySwitch!.querySelector(".text")!;

btn?.addEventListener("click", () => {
  modal?.classList.toggle("hidden");
  const country = modal?.querySelector<HTMLSelectElement>("#country")?.value ?? "";
  const language = modal?.querySelector<HTMLSelectElement>("#language")?.value ?? "";
  txtLang.setAttribute("data-i18n", "lang-" + language);
  txtCountry.setAttribute("data-i18n", "country-" + country);
  setCountryAndLanguage(country, language);
  translate();
  // modal?.parentNode?.removeChild(modal);
});

btnLangSwitch?.addEventListener("click", () => {
  modal?.classList.toggle("hidden");
  translate();
  // modal?.parentNode?.removeChild(modal);
});
btnCountrySwitch?.addEventListener("click", () => {
  modal?.classList.toggle("hidden");
  translate();
  // modal?.parentNode?.removeChild(modal);
});
translate();
console.log("asd");
*/
